
import { useTranslation } from 'react-i18next';

export default function ServiceProcess() {
  const { t } = useTranslation('home');
  
  const processes = [
    {
      title: t('serviceProcess.steps.0.title'),
      description: t('serviceProcess.steps.0.description'),
      icon: 'ri-chat-3-line'
    },
    {
      title: t('serviceProcess.steps.1.title'),
      description: t('serviceProcess.steps.1.description'),
      icon: 'ri-file-text-line'
    },
    {
      title: t('serviceProcess.steps.2.title'),
      description: t('serviceProcess.steps.2.description'),
      icon: 'ri-pencil-ruler-2-line'
    },
    {
      title: t('serviceProcess.steps.3.title'),
      description: t('serviceProcess.steps.3.description'),
      icon: 'ri-checkbox-circle-line'
    },
    {
      title: t('serviceProcess.steps.4.title'),
      description: t('serviceProcess.steps.4.description'),
      icon: 'ri-code-s-slash-line'
    },
    {
      title: t('serviceProcess.steps.5.title'),
      description: t('serviceProcess.steps.5.description'),
      icon: 'ri-bug-line'
    },
    {
      title: t('serviceProcess.steps.6.title'),
      description: t('serviceProcess.steps.6.description'),
      icon: 'ri-customer-service-2-line'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">{t('serviceProcess.title')}</h2>
          <p className="text-lg text-gray-600">{t('serviceProcess.subtitle')}</p>
        </div>

        {/* Process Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-7 gap-6">
          {processes.map((process, index) => (
            <div key={index} className="text-center group">
              {/* Circle with Icon */}
              <div className="relative mb-6">
                <div className="w-32 h-32 mx-auto rounded-full bg-white shadow-lg flex items-center justify-center group-hover:shadow-xl transition-all duration-300 group-hover:scale-110 border-4 border-gray-100">
                  <div className="w-24 h-24 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center">
                    <i className={`${process.icon} text-4xl text-white`}></i>
                  </div>
                </div>
                {/* Step Number */}
                <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-8 h-8 bg-indigo-600 rounded-full flex items-center justify-center text-white font-bold text-sm shadow-md">
                  {index + 1}
                </div>
              </div>

              {/* Content */}
              <h3 className="text-lg font-bold text-gray-900 mb-2">{process.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{process.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
